import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_3 = { class: "sm:col-span-5" }
const _hoisted_4 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_6 = { class: "sm:col-span-5" }
const _hoisted_7 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_8 = { class: "mt-4 grid grid-cols-2 place-content-around gap-4" }

import { computed, Ref, ref, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';

import { useFilterStore } from '@/stores';
import { SelectOptionsService } from '@/services';
import { toastServiceError } from '@/services/core/notification';

import {
    AgentProductivityPerDayReportActions,
    AgentProductivityPerDayReportFilter,
    AgentProductivityPerDayReportGetters,
    LevelModel,
    SelectOptionsServiceGetUserLabelsResult,
    SelectOptionsServiceGetUsersResult,
} from '@/types';

import { FilterIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentProductivityPerDayReportFilters',
  setup(__props) {

const userOptions: Ref<SelectOptionsServiceGetUsersResult[]> = ref([]);
const userLabelOptions: Ref<SelectOptionsServiceGetUserLabelsResult[]> = ref([]);

const levelFilter = computed<LevelModel | null>(() => filterStore.level);
const defaultFilter = computed(
    () => store.getters[AgentProductivityPerDayReportGetters.DEFAULT_FILTER],
);
const filterOpened = ref(false);
const filter: Ref<AgentProductivityPerDayReportFilter> = ref({
    user: defaultFilter.value.user,
    userLabel: defaultFilter.value.userLabel,
});
const storeFilter = computed(() => store.getters[AgentProductivityPerDayReportGetters.FILTER]);

const filterStore = useFilterStore();
const { t } = useI18n();

watch(filterOpened, () => {
    refreshLocalFilter();
});

watch(levelFilter, () => {
    store.dispatch(AgentProductivityPerDayReportActions.CLEAR_FILTER, 'user');
    fetchUsers();
    fetchUserLabels();
});

const fetchUsers = async () => {
    try {
        const response = await SelectOptionsService.getUsers();
        userOptions.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const fetchUserLabels = async () => {
    try {
        const response = await SelectOptionsService.getUserLabels();
        userLabelOptions.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const applyFilters = () => {
    store.dispatch(AgentProductivityPerDayReportActions.SET_FILTER, filter.value);
};

const clearFilters = () => {
    store.dispatch(AgentProductivityPerDayReportActions.CLEAR_FILTER);
    refreshLocalFilter();
};

const refreshLocalFilter = () => {
    filter.value.user = storeFilter.value.user;
    filter.value.userLabel = storeFilter.value.userLabel;
};

onMounted(() => {
    fetchUsers();
    fetchUserLabels();
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: filterOpened.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterOpened).value = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode(_component_UiButton, {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filterOpened.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterIcon), {
            class: "mr-3 h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('core.actions.Filter')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('report.agentProductivityPerAgent.filters.userLabel')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filter_user_label",
              modelValue: filter.value.userLabel,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.userLabel) = $event)),
              label: "label",
              "value-prop": "id",
              options: userLabelOptions.value,
              "can-clear": "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('report.agentProductivityPerDay.filters.user')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filter_user",
              modelValue: filter.value.user,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.user) = $event)),
              label: "name",
              "value-prop": "id",
              options: userOptions.value,
              "can-clear": "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (clearFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (applyFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})